import Dispatcher from '../dispatcher';
import formatAddress from '../../utilities/format_address';
import { getMap } from '../helper/gmap';
import resolvePromise from '../helper/resolved_promise';
import { getValue } from '../../utilities/local_storage';

const MapActions = {
    updateLatLngAction(payload) {
        const prom = $.Deferred();

        if (getMap()) {
            Dispatcher.handleMapAction({ type: 'FETCH_LATLNG' });
            this._getLatLng(payload).done((latLng) => {
                Dispatcher.handleMapAction({
                    type: 'LATLNG_FETCHED',
                    payload: latLng,
                });
                prom.resolve();
            });
        } else {
            const latLngData = getValue('latLng');
            
            if (latLngData) {
                Dispatcher.handleMapAction({ type: 'FETCH_LATLNG' });
                const latLng = {
                    lat: () => latLngData.lat,
                    lng: () => latLngData.lng,
                };
                Dispatcher.handleMapAction({
                    type: 'LATLNG_FETCHED',
                    payload: latLng,
                });
                prom.resolve();
            } else {
                window.location.reload();
            }

        }
        return prom;
    },
    setLatLngAction(payload) {
        Dispatcher.handleMapAction({
            type: 'SET_LATLNG',
            payload,
        });

        return resolvePromise();
    },
    updateZoomLevelAction(payload) {
        Dispatcher.handleMapAction({
            type: 'UPDATE_ZOOM_LVL',
            payload,
        });

        return resolvePromise();
    },

    _getLatLng(postcode) {
        return getMap().getLatLng(formatAddress(postcode));
    },
};

export default MapActions;
